// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2423af80","455":"7530b5d6","977":"8f581a1b"}[chunkId] + ".chunk.js";
};